import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'label', 'persistedFile'];

  connect() {
    // Store the original label text
    if (this.hasLabelTarget) {
      this.originalText =
        this.labelTarget.dataset.defaultText || this.labelTarget.textContent;
    }
  }

  updateFilename() {
    if (!this.hasLabelTarget) return;

    const file = this.inputTarget.files?.[0];

    if (file) {
      // New file selected
      this.labelTarget.textContent = file.name;
      this.labelTarget.classList.add('has-file');

      // Hide the persisted file description if it exists
      if (this.hasPersistedFileTarget) {
        this.persistedFileTarget.style.display = 'none';
      }
    } else {
      // No file selected (cleared)
      this.labelTarget.textContent = this.originalText;
      this.labelTarget.classList.remove('has-file');

      // Show the persisted file description again if it exists
      if (this.hasPersistedFileTarget) {
        this.persistedFileTarget.style.display = '';
      }
    }
  }
}
